<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 text-left pb-2>
        <span class="mainHeader">DISCOUNT APPROVALS</span>
      </v-flex>
      <v-flex xs12 pb-4 class="tablefont">
        Sales staff can still apply a discount above your threshold immediately -- this is a review queue, not a hard block, so a large sale never gets stuck waiting on approval.
      </v-flex>
      <v-flex xs12 py-2 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="approvalList.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Date</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Bill No</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Requested By</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Discount Amount</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Status</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in approvalList" :key="i" class="table">
                      <td>{{ formatDate(value.create_date) }}</td>
                      <td>{{ value.salesId ? ((value.salesId.billPrefix || '') + value.salesId.billNo) : "-" }}</td>
                      <td>
                        <span v-if="value.requestedBy">{{ value.requestedBy.firstname }} {{ value.requestedBy.lastname }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>₹{{ value.discountAmount }}</td>
                      <td>{{ value.status }}</td>
                      <td>
                        <v-btn v-if="value.status == 'Pending'" x-small color="#3F053C" dark class="mr-2" @click="decide(value, 'Approved')">Approve</v-btn>
                        <v-btn v-if="value.status == 'Pending'" x-small outlined color="#3F053C" @click="decide(value, 'Rejected')">Reject</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No discounts flagged for review.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      approvalList: [],
    };
  },
  mounted() {
    this.getApprovalList();
  },
  methods: {
    getApprovalList() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/discountapproval/list",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.approvalList = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    decide(item, decision) {
      axios({
        method: "post",
        url: "/discountapproval/decide",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: item._id, decision: decision },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.getApprovalList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    },
  },
};
</script>
